import { hasPremiumUserSelect } from 'modules/training/modules/training-users/selectors/has-premium/index.js'
import loadReduxAction from 'modules/redux/actions/load'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getPathFromDomainPathReduxUtil from 'modules/redux/utils/get-path-from-domain-map-path'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import { TRAINING_PLAN_CLASS_NAME } from 'modules/training/models/plan/constants'
import {
  PLANS_ACTION,
  PLANS_DOMAIN,
  PLANS_ENDPOINT,
  PLANS_PATH
} from 'modules/plan/redux/constants'
import { getCreatorProfileSelect } from 'modules/profile/redux/selectors/is-admin'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import {
  getObjectUtil,
  logUtil
} from 'packages/src'
import saveReduxAction from 'modules/redux/actions/save'
import { getCurrentPlanSelect } from 'modules/plan/redux/selectors'
import REDUX_OPTION from 'modules/redux/constants/option'
import {
  getCurrentProfileSelect,
  updateCurrentPlanAction
} from '@gymaholic/packages'
import createReduxAction from 'modules/redux/actions/create'
import getPathReduxUtil from 'modules/redux/utils/get-path'

export function loadCreatorPlansAction (params = {}) {
  return async (dispatch, getState) => {
    const creatorId = getIdReduxUtil(getCreatorProfileSelect(getState()))
    if (!creatorId) {
      logUtil('loadCreatorPlansAction')
        .warn('creatorId not provided')
      return
    }

    const endpoint = getEndpointTrainingUtil(interpolateRouteUtil(PLANS_ENDPOINT.LOAD_CREATOR_PLANS,
      {
        creatorId
      }
    ))
    try {
      await dispatch(loadReduxAction({
        type: PLANS_ACTION.LOAD_CREATOR_PLANS,
        path: PLANS_DOMAIN,
        payload: {
          endpoint,
          domainListPath: PLANS_PATH.ALL
        },
        options: params.options
      }))
    } catch (error) {
      logUtil('loadCreatorPlansAction')
        .error('loading creator plans failed ', error)
    }
  }
}

export function loadCurrentCreatorProfilePlansAction (params = {}) {
  return async (dispatch, getState) => {
    const creatorId = getIdReduxUtil(getCurrentProfileSelect(getState()))
    if (!creatorId) {
      logUtil('loadCreatorPlansAction')
        .warn('creatorId not provided')
      return
    }

    const endpoint = getEndpointTrainingUtil(interpolateRouteUtil(PLANS_ENDPOINT.LOAD_CREATOR_PLANS,
      {
        creatorId
      }
    ))
    try {
      await dispatch(loadReduxAction({
        type: PLANS_ACTION.LOAD_CREATOR_PLANS,
        path: PLANS_DOMAIN,
        payload: {
          endpoint,
          domainListPath: PLANS_PATH.ALL
        },
        options: params.options
      }))
    } catch (error) {
      logUtil('loadCreatorPlansAction')
        .error('loading creator plans failed ', error)
    }
  }
}

export function loadCreatorPlanByIdAction (params = {}) {
  return async (dispatch, getState) => {
    const id = params.id || getObjectUtil(params, 'match.params.id')
    const creatorId = getIdReduxUtil(getCreatorProfileSelect(getState()))
    logUtil('loadCreatorPlanByIdAction')
      .debug(`loading creator plan with id ${id}`)
    if (!id) {
      logUtil('loadCreatorPlanByIdAction')
        .warn('id not provided')
      return
    }

    if (!creatorId) {
      logUtil('loadCreatorPlanByIdAction')
        .warn('creatorId not provided')
      return
    }

    const endpoint = getEndpointTrainingUtil(interpolateRouteUtil(PLANS_ENDPOINT.LOAD_CREATOR_PLAN,
      {
        id,
        creatorId
      }
    ))
    try {
      await dispatch(loadReduxAction({
        type: PLANS_ACTION.LOAD_CREATOR_PLAN,
        payload: {
          endpoint,
          domainListPath: PLANS_PATH.ALL,
          path: getPathFromDomainPathReduxUtil(PLANS_DOMAIN, id),
          data: {
            id,
            className: TRAINING_PLAN_CLASS_NAME
          }
        },
        options: params.options
      }))
    } catch (error) {
      logUtil('loadCreatorPlanByIdAction')
        .error('loading creator plans failed ', error)
    }
  }
}

export function purchasePlanAction (payload, planId) {
  return async (dispatch) => {
    try {
      const response = await dispatch(saveReduxAction({
        type: PLANS_ACTION.PURCHASE_PLAN,
        payload: {
          data: payload,
          endpoint: getEndpointTrainingUtil(interpolateRouteUtil(PLANS_ENDPOINT.PURCHASE_PLAN, { id: planId }))
        }
      }))

      return response
    } catch (error) {
      logUtil('purchasePlan')
        .error('purchasePlan: ', error)

      return error
    }
  }
}

export function loadStartedPlansAction () {
  return async (dispatch, getState) => {
    if (!hasPremiumUserSelect(getState())) {
      return
    }

    try {
      await dispatch(
        loadReduxAction({
          type: PLANS_ACTION.LOAD_STARTED_PLANS,
          payload: {
            endpoint: getEndpointTrainingUtil(interpolateRouteUtil(PLANS_ENDPOINT.LOAD_PLANS)),
            domainListPath: PLANS_PATH.STARTED_PLANS,
            query: {
              isStarted: true
            },
            options: {
              [REDUX_OPTION.IGNORE_UPDATED_AT]: true
            }
          }
        })
      )
    } catch (error) {
      logUtil('loadStartedPlansAction')
        .error('loadStartedPlansAction: ', error)
      return error
    }
  }
}

export function createPlanAction (payload) {
  return async (dispatch) => {
    try {
      const plan = dispatch(createReduxAction({
        type: PLANS_ACTION.CREATE_PLAN,
        payload: {
          data: {
            className: TRAINING_PLAN_CLASS_NAME
          }
        }
      }))
      dispatch(updateCurrentPlanAction(plan))
      const response = await dispatch(saveReduxAction({
        type: PLANS_ACTION.CREATE_PLAN,
        payload: {
          data: payload,
          endpoint: getEndpointTrainingUtil(PLANS_ENDPOINT.LOAD_PLANS),
          path: getPathReduxUtil(plan)
        }
      }))
      dispatch(updateCurrentPlanAction(response.data.plan))
    } catch (error) {
      logUtil('createPlanAction')
        .error('creating plan failed: ', error)
    }
  }
}

export function updatePlanByIdAction (payload, id) {
  return async (dispatch, getState) => {
    try {
      const plan = getCurrentPlanSelect(getState())
      const response = await dispatch(saveReduxAction({
        type: PLANS_ACTION.UPDATE_PLAN,
        payload: {
          // Need to pass the data from the outside and make a PUT request and save the response in the state
          data: payload,
          endpoint: getEndpointTrainingUtil(interpolateRouteUtil(PLANS_ENDPOINT.LOAD_BY_ID, { id })),
          path: getPathReduxUtil(plan),
          method: 'PUT'
        }
      }))
      dispatch(updateCurrentPlanAction(response.data.plan))
    } catch (error) {
      logUtil('updatePlanAction')
        .error('updating plan failed: ', error)
    }
  }
}
